import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Agent, AgentClient, DocumentTypeClient, DocumentTypes } from "src/app/web-api-client";

@Component({
  selector: 'app-documentType-edit',
  templateUrl: './documentType-edit.component.html',
  styleUrls: ['./documentType-edit.component.scss']
})
export class DocumentTypeEditComponent implements OnInit {


  public onClose = new Subject<boolean>();
  public isLoaded = true;
  public editObject: DocumentTypes;

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: DocumentTypeClient) { }

  ngOnInit(): void {

    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {


      this.editObject.title = this.Form.value.title;
      this.editObject.isActive = this.Form.value.isActive;




      this.client.update(this.editObject).subscribe((user) => {

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
